import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../shared/types';
import { handleError } from '../../../ui/err/handleError';
import { relayPointApis } from '../../../../shared/apis/relayPoint/apis';

export const useDataPointOrderList = ({
  queryKey,
  query,
}: {
  queryKey: (string | number | object)[];
  query: {
    searchType: string;
    searchWord: string;
    page: number;
    size: number;
    statusCd: number;
  };
}) => {
  return useQuery(queryKey, () => relayPointApis.getRelayPointOrderList({ ...query }), {
    refetchOnWindowFocus: false,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
};
